module.exports = __webpack_public_path__ + "img/zhekou.3c8ce313.png";